import React, {useRef, useState} from "react";
import {getVimeoVideo, getYoutubeVideo} from "Helpers/VideoHelper";
import {Thumbnail, VideoButton, VideoControl, VideoIframe, VideoWrapper} from "./Video.styles";

export const Video = ({VideoType, Heading, VideoLink, Image, isBlock = false, videoHeight = null, ...rest}) => {

    const [videoUrl, setVideoUrl] = useState("");
    const [useVideoControl, setUseVideoControl] = useState(false);
    const videoRef = useRef();
    const imgRef = useRef();
    const handleClick = () => {
        switch (VideoType) {
            case "youtube":
                setUseVideoControl(false);
                setVideoUrl(getYoutubeVideo(VideoLink));
                break;
            case "vimeo":
                setUseVideoControl(false);
                setVideoUrl(getVimeoVideo(VideoLink));
                break;
            case "frontify":
                setUseVideoControl(true);
                setVideoUrl(`${VideoLink}`);
                break;
        }

        if (imgRef != undefined) imgRef.current.style.opacity = 0;
    };
    return (
        <VideoWrapper videoHeight={videoHeight} className={"v--video"}>
            <VideoButton position={'center'} onClick={handleClick}>
                <i className="icon-play" aria-hidden="true"></i>
            </VideoButton>
            <Thumbnail ref={imgRef} bgImage={Image}></Thumbnail>
            {videoUrl && (
                useVideoControl ?
                    <VideoControl autoPlay>
                        <source src={videoUrl}/>
                    </VideoControl> :
                    <VideoIframe
                        videoType={VideoType}
                        frameBorder="0"
                        allow="autoplay *;"
                        title=" video"
                        ref={videoRef}
                        src={videoUrl}
                    />


            )}
        </VideoWrapper>
    );
};
